@let currentField = getCurrentField();
@let isBlocked = editService.loading() || editDataService.currentSessionIsDisabled() || editDataService.documentIsBlocked();

<card-base
    [field]="field()"
    [favoriteField]="favoriteField()"
    [trashField]="trashField()"
    [type]="type()"
    [disabled]="isBlocked"
    [selected]="selected()">

    <!-- O texto é o próprio editor. Tipo, tamanho e cor ficam na barra do topo do editor
         (edit-toolbar), por isso o rail deste card não tem paleta. -->
    <inline-text-editor
        [field]="currentField"
        target="value"
        [placeholder]="(currentField.type === textTypes.TITLE ? 'document.edit.textCard.typeTitle' : 'document.edit.textCard.placeholder') | translate"
        [readonly]="type() !== 'default'"
        [blocked]="isBlocked"
        [class.is-title]="currentField.type === textTypes.TITLE"
        [class.is-subtitle]="currentField.type === textTypes.SUBTITLE" />
</card-base>
